import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {FITH2SoundManager} from "../sound/FITH2SoundManager";
import {FITH2SoundConfig} from "../configs/FITH2SoundConfig";
import {FireInTheHole2} from "../FireInTheHole2";
import {APISetting} from "@nolimit/slot-launcher/bin/interfaces/APISettingsSystem";
import {IBetWayWinData} from "@nolimit/slot-game/bin/utils/server/IData";
import {gsap} from "gsap";
import {FITH2WinConfig} from "../configs/FITH2WinConfig";
import {FITH2Helper} from "../utils/FITH2Helper";
import {ArrayHelper} from "@nolimit/slot-game/bin/utils/ArrayHelper";
import {FITH2Symbol} from "../symbols/FITH2Symbol";
import {NolimitConfig} from "@nolimit/slot-launcher/bin/settings/NolimitConfig";
import {IFITH2GameData} from "../server/IFITH2Data";
import {NolimitApplication} from "@nolimit/slot-launcher/bin/NolimitApplication";

export class FITH2InitialWinPresentation implements SimplePresentation {
    constructor() {
    }

    shouldRun(): boolean {
        return FireInTheHole2.model.isNextRespin && !FireInTheHole2.model.gameData.wildMiningTriggered;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline(),
            isLargerWin: boolean = FireInTheHole2.model.currentWinRatio >= FITH2WinConfig.WIN_RATIOS.normalWin[3].ratio,
            delayBetweenReelHighlight: number = (isLargerWin ? 0.12 : 0),
            delayBetweenReel: number = (isLargerWin ? 0.1 : 0),
            toggleType: string = FITH2Helper.getToggleType(),
            soundPlayedOnReel: boolean[] = ArrayHelper.initArrayWithValues(6, () => false),
            gameData: IFITH2GameData = FireInTheHole2.model.gameData,
            hasBomb: boolean = FireInTheHole2.model.wildOnReel.indexOf(true) > -1,
            fast: boolean = FireInTheHole2.apiPlugin.settings.get(APISetting.FAST_SPIN);

        let explosionSounds: string[] = [];
        if (isLargerWin) {
            explosionSounds = ArrayHelper.shuffle(FITH2SoundConfig.WIN_EXPLOSION_MULTI);
        }
        const toggleSounds = ArrayHelper.shuffle(isLargerWin ? FITH2SoundConfig.WIN_HIGHLIGHT_HIGH : FITH2SoundConfig.WIN_HIGHLIGHT_LOW);
        const explodeLineTimeLine: gsap.core.Timeline = gsap.timeline();
        const bombExplodeLineTimeLine: gsap.core.Timeline = gsap.timeline();
        tl.add(() => controller.setSkipCallback(() => {
            tl.timeScale(2);
            FITH2SoundManager.stopSoundEffect("wildBuildup");
            explodeLineTimeLine.timeScale(2);
        }));

        let bombCounter: number = 0;
        gameData.betWayWins.forEach((betWayWin: IBetWayWinData, l: number) => {
            const winLineTL: gsap.core.Timeline = gsap.timeline(),
                winNumPlayPosition: number[] = FireInTheHole2.initialWinView.findLastNoWildSymbolPosition(betWayWin);
            betWayWin.reelWinPositions.forEach((reelWin: boolean[], i: number) => {
                reelWin.forEach((winPos: boolean, j: number) => {
                    if (winPos) {
                        const sym: FITH2Symbol = FireInTheHole2.reelArea.getSymbol([i, j]);
                        if (i === winNumPlayPosition[0] && j === winNumPlayPosition[1]) {
                            winLineTL.add(() => {
                                FireInTheHole2.initialWinView.playWinNumbers(betWayWin, false, winNumPlayPosition)
                            }, i * delayBetweenReelHighlight);
                        }

                        bombCounter += (sym.symName === "W" ? 1 : 0);
                        winLineTL.add(sym.playInitialWin(toggleType), 0);
                    }
                });
            });
            tl.add([
                () => {
                    if (l === 0) {
                        FireInTheHole2.reelBackground.onWinToggle();
                    }
                    FITH2SoundManager.playSound(toggleSounds[l % 3]);
                },
                winLineTL
            ]);
        });
        const bombDelay: number = (hasBomb ? 17 * 0.033 : 0);
        let bombExplodeDelay: number = 0;
        if (hasBomb) {
            bombExplodeLineTimeLine.add(() => {
                FireInTheHole2.gameViewContainer.onBombExplode();
                FITH2SoundManager.playSound("wildExplosion");
            }, bombDelay);
        }
        gameData.evaluatedArea.forEach((reel: string[], reelId: number) => {
            reel.forEach((symName: string, symId: number) => {
                let isWild: boolean = symName[0] === "W",
                    toExplode: boolean = ((gameData.removedSymbols[reelId][symId] === "M") || (symName != gameData.removedSymbols[reelId][symId])),
                    explodeTime: number = reelId * delayBetweenReel;

                if (toExplode) {
                    const sym: FITH2Symbol = FireInTheHole2.reelArea.getSymbol([reelId, symId]);
                    if (isLargerWin && !soundPlayedOnReel[reelId]) {
                        explodeLineTimeLine.add(() => {
                            FITH2SoundManager.playSound(explosionSounds[reelId]);
                        }, explodeTime);
                        soundPlayedOnReel[reelId] = true;
                    }

                    if (isWild) {
                        bombExplodeLineTimeLine.add([
                            () => {
                                FITH2SoundManager.playSound("wildBuildup");
                            },
                            sym.explode(toggleType, FireInTheHole2.model.barId)
                        ], bombExplodeDelay);
                        bombExplodeLineTimeLine.add([
                            FireInTheHole2.initialWinView.addMulti([reelId, symId]),
                            FireInTheHole2.multiplier.addOne(sym.symSize),
                            () => {
                                if (fast){
                                    FITH2SoundManager.stopSoundEffect("wildBuildup");
                                }
                            }
                        ], bombExplodeDelay + bombDelay);
                        bombExplodeDelay += 0.2;
                    } else {
                        explodeLineTimeLine.add(sym.explode(toggleType, FireInTheHole2.model.barId), explodeTime + (sym.isWinSymbol ? 0 : bombDelay));
                    }
                }
            });
        });
        tl.add([
            () => {
                if (!isLargerWin && gameData.betWayWins.length>0) {
                    FITH2SoundManager.playSound(FITH2SoundConfig.WIN_EXPLOSION_SINGLE);
                }
            },
            bombExplodeLineTimeLine,
            explodeLineTimeLine
        ], `-=${gameData.betWayWins.length > 0 ? 0.2 : 0}`);
        if (FireInTheHole2.model.isNormal) {
            tl.add([
                () => {
                    FireInTheHole2.reelArea.updateNewSymbolBehindBar();
                },
                FireInTheHole2.reelTopBar.updateBars()
            ], "-=0.5");
        }

        tl.add([
            () => {
                FireInTheHole2.keypadPlugin.setWin(gameData.accumulatedRoundWin, true, FITH2Helper.isWinBelowStake());
                controller.finish();
                if (NolimitConfig.isDevMode) {
                    FireInTheHole2.multiplier.checkServerData();
                }
            }
        ], "-=0.5");

        if (fast) {
            tl.timeScale(1.4);
        }

    }
}